function FlagKH({ className = "w-4 h-3 shrink-0" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 16" fill="none">
      <rect width="24" height="4" fill="#032EA6" />
      <rect y="4" width="24" height="8" fill="#E00025" />
      <rect y="12" width="24" height="4" fill="#032EA6" />
      <path d="M7 11h10v1H7v-1zm1-2h8v2H8V9zm1-2h6v2H9V7zm2-2h2v2h-2V5zm-2 2h1v2H9V7zm5 0h1v2h-1V7z" fill="#FFFFFF" />
    </svg>
  );
}

function FlagUS({ className = "w-4 h-3 shrink-0" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 16" fill="none">
      <rect width="24" height="16" fill="#B22234" />
      <path d="M0 2.46h24M0 4.92h24M0 7.38h24M0 9.85h24M0 12.31h24M0 14.77h24" stroke="#FFFFFF" strokeWidth="1.23" />
      <rect width="9.6" height="8.6" fill="#3C3B6E" />
      <circle cx="2" cy="2" r="0.6" fill="#FFFFFF" />
      <circle cx="5" cy="2" r="0.6" fill="#FFFFFF" />
      <circle cx="8" cy="2" r="0.6" fill="#FFFFFF" />
      <circle cx="3.5" cy="4.3" r="0.6" fill="#FFFFFF" />
      <circle cx="6.5" cy="4.3" r="0.6" fill="#FFFFFF" />
      <circle cx="2" cy="6.6" r="0.6" fill="#FFFFFF" />
      <circle cx="5" cy="6.6" r="0.6" fill="#FFFFFF" />
      <circle cx="8" cy="6.6" r="0.6" fill="#FFFFFF" />
    </svg>
  );
}

function FlagGB({ className = "w-4 h-3 shrink-0" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 16" fill="none">
      <rect width="24" height="16" fill="#012169" />
      <path d="M0 0l24 16M24 0L0 16" stroke="#FFFFFF" strokeWidth="3.2" />
      <path d="M0 0l24 16M24 0L0 16" stroke="#C8102E" strokeWidth="1.2" />
      <path d="M12 0v16M0 8h24" stroke="#FFFFFF" strokeWidth="5.2" />
      <path d="M12 0v16M0 8h24" stroke="#C8102E" strokeWidth="3" />
    </svg>
  );
}

function FlagCN({ className = "w-4 h-3 shrink-0" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 16" fill="none">
      <rect width="24" height="16" fill="#DE2910" />
      <polygon points="4,2.5 4.8,5 2.8,3.5 5.2,3.5 3.2,5" fill="#FFDE00" />
      <polygon points="7,2 7.4,3 6.4,2.4 7.6,2.4 6.6,3" fill="#FFDE00" />
      <polygon points="8,4 8.4,5 7.4,4.4 8.6,4.4 7.6,5" fill="#FFDE00" />
      <polygon points="8,6.5 8.4,7.5 7.4,6.9 8.6,6.9 7.6,7.5" fill="#FFDE00" />
      <polygon points="7,8.5 7.4,9.5 6.4,8.9 7.6,8.9 6.6,9.5" fill="#FFDE00" />
    </svg>
  );
}

function FlagTH({ className = "w-4 h-3 shrink-0" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 16" fill="none">
      <rect width="24" height="2.67" fill="#A51931" />
      <rect y="2.67" width="24" height="2.67" fill="#F4F5F8" />
      <rect y="5.33" width="24" height="5.33" fill="#2D2A4A" />
      <rect y="10.67" width="24" height="2.67" fill="#F4F5F8" />
      <rect y="13.33" width="24" height="2.67" fill="#A51931" />
    </svg>
  );
}

function FlagVN({ className = "w-4 h-3 shrink-0" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 16" fill="none">
      <rect width="24" height="16" fill="#DA251D" />
      <polygon points="12,4 13.5,8.5 18,8.5 14.5,11.2 16,15.5 12,12.8 8,15.5 9.5,11.2 6,8.5 10.5,8.5" fill="#FFFF00" />
    </svg>
  );
}

function FlagSG({ className = "w-4 h-3 shrink-0" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 16" fill="none">
      <rect width="24" height="8" fill="#ED2939" />
      <rect y="8" width="24" height="8" fill="#FFFFFF" />
      <circle cx="5" cy="4" r="2.5" fill="#FFFFFF" />
      <circle cx="6" cy="4" r="2.3" fill="#ED2939" />
      <circle cx="7.2" cy="3" r="0.4" fill="#FFFFFF" />
      <circle cx="8" cy="4" r="0.4" fill="#FFFFFF" />
      <circle cx="7.2" cy="5" r="0.4" fill="#FFFFFF" />
      <circle cx="6.5" cy="4.5" r="0.4" fill="#FFFFFF" />
      <circle cx="6.5" cy="3.5" r="0.4" fill="#FFFFFF" />
    </svg>
  );
}

function FlagMY({ className = "w-4 h-3 shrink-0" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 16" fill="none">
      <rect width="24" height="16" fill="#CC0000" />
      <path d="M0 1.14h24M0 3.43h24M0 5.71h24M0 8h24M0 10.29h24M0 12.57h24M0 14.86h24" stroke="#FFFFFF" strokeWidth="1.14" />
      <rect width="12" height="9.14" fill="#000066" />
      <circle cx="4.8" cy="4.5" r="2.5" fill="#FFCC00" />
      <circle cx="5.6" cy="4.5" r="2.2" fill="#000066" />
      <circle cx="8" cy="4.5" r="1.4" fill="#FFCC00" />
    </svg>
  );
}

export default function CountryFlag({ iso, className = "w-4 h-3 shrink-0" }: { iso: string; className?: string }) {
  switch (iso.toUpperCase()) {
    case "KH": return <FlagKH className={className} />;
    case "US": return <FlagUS className={className} />;
    case "GB": return <FlagGB className={className} />;
    case "CN": return <FlagCN className={className} />;
    case "TH": return <FlagTH className={className} />;
    case "VN": return <FlagVN className={className} />;
    case "SG": return <FlagSG className={className} />;
    case "MY": return <FlagMY className={className} />;
    default: return <FlagKH className={className} />;
  }
}
